import { CheckCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import * as APITypes from "~/API";
import { COLORS } from "~/utils";

export const TenantNameTag = ({
  name,
  status,
  authType,
  authID,
}: {
  name: string;
  authID: string;
  status: APITypes.TenantStatusType;
  authType: APITypes.TenantType;
}) => {
  let color = COLORS.grey;
  let authSymbol = <QuestionCircleOutlined />;

  if (authType === APITypes.TenantType.AuthenticatedTenant || authID !== "") {
    authSymbol = <CheckCircleOutlined />;
  }

  if (status === APITypes.TenantStatusType.Active) {
    color = COLORS.vibrant_green;
  }

  return (
    <Tag color={color}>
      {authSymbol} {name}
    </Tag>
  );
};
